import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {PolicyService} from '../../../policy/services/policy.service';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {Policy} from '../../models/policy.model';
import {PolicyStore} from '../../../policy/state/policy.store';
import {UserStore} from '../../../authentication/state/user.store';
import {RouterLinks, Superflow} from '../../constants';
import {UnderwriterService} from '../../../underwriter/services/underwriter.service';
import {QuotesService} from 'src/app/modules/quotes/services/quotes.service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ClaimGuardService} from '../../services/claim-guard.service';
import {GetPoliciesRequest} from '../../models/get-policies-request.model';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
import {QuestionFlowSessionStore} from '../../questions/state/question-flow-session.store';
import { ClaimsService } from 'src/app/modules/claim/services/claims.service';
import { ShoppingCartStore } from '../../questions/state/shopping-cart-store';
import { ShoppingCartItem } from '../../models/underwriter.model';
import { PushNotifications } from '@capacitor/push-notifications';
import { ClaimStore } from 'src/app/modules/claim/state/state/claims-session.store';
import { FlowPlayerService } from '../../services/flow-player.service';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import {PausePolicyComponent} from '../policy-actions/pause-resume-policy/pause-policy/pause-policy.component';
import { Alert } from '../../utilities';
import { CancelPolicyComponent } from '../policy-actions/cancel-restore-policy/cancel-policy/cancel-policy.component';
import { ResumePolicyComponent } from '../policy-actions/pause-resume-policy/resume-policy/resume-policy.component';
import { RestorePolicyComponent } from '../policy-actions/cancel-restore-policy/restore-policy/restore-policy.component';
import { EmergencyServicesModalComponent } from '../../../claim/emergency-services-modal/emergency-services-modal.component';


enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}
declare var $: any;
declare var accounting: any;
declare function notify(): any;
declare function initTableSearch($input: any): any;
declare function initTableSort($control: any): any;
declare function genMobileTableLabels($input: any): any;
declare function initCustomDropdowns(): any;
declare function initFilters($elements: any): any;
//declare function initGlobalSearch(): any;
declare function initSearchRangeDatePicker(): any;

@Component({
    selector: 'app-policy-holders',
    templateUrl: './policy-holders.component.html',
    styleUrls: ['./policy-holders.component.scss'],
    standalone: false
})
export class PolicyHoldersComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  @ViewChild('pausePolicyComponent', {static: false}) pausePolicyComponent: PausePolicyComponent;
  @ViewChild('cancelPolicyComponent', {static: false}) cancelPolicyComponent: CancelPolicyComponent;
  @ViewChild('resumePolicyComponent', {static: false}) resumePolicyComponent: ResumePolicyComponent;
  @ViewChild('restorePolicyComponent', {static: false}) restorePolicyComponent: RestorePolicyComponent;
  @ViewChild('emergencyServicesModalComponent', {static: false}) emergencyServicesModalComponent: EmergencyServicesModalComponent;
  @ViewChild('viewElement') viewElement: any;
  dtOptions: any = {};
  // bumped from the legacy numeric-index scheme; old prefs are ignored (all columns show)
  readonly COLUMN_PREFS_KEY = 'policyHolders_columnPrefs_v2';
  request = new GetPoliciesRequest();
  person: any;
  policies: Policy[] = [];
  tablePolicies: Policy[] = [];
  accounting: any;
  categories: any[] = [];
  notify: any;
  selectedEntity = Entity.Policy;
  showTableContent = false;
  statusFilterAll = 'All';
  productFilterAll = 'All';
  question: any;
  brokers: any[] = [];
  insurers: any[] = [];
  users: any[] = [];
  broker_id = 0;
  RouterLinks = RouterLinks;
  selectedInsurer: any;
  mode = 'Policies';
  search_query = '';
  //searchChanged = new Subject<string>();
  brokerage_ids = [];
  broker_ids = [];
  statuses = [];
  status_ids = [1];
  product_ids = [];
  underwriting = false;
  claims = false;
  uwDataset: any;
  uwView = 'Policies';
  sort: string = 'name';
  order: string = 'asc';
  selectedPolicy: any;
  frequency_id = 3;
  moreActiveDesktop = false;
  moreActiveMobile = false;
  selectedDesktopIdx = 0;
  selectedIdx = 0;
  isEmpty = false;
  responsetext = '';
  options: any = [];
  reason = {id: 0, text: ""};
  reasonProvided = false;
  uwDate = '';
  blacklistReason = '';
  mobileSort = false;
  SortColumns = [
    { id: 'name', name: 'Client' },
    { id: 'policy_id', name: 'Policy/Quote No.' },
    { id: 'product_id', name: 'Product' },
    { id: 'policy_status', name: 'Status' },
    { id: 'uw_flag', name: 'UW' },
    { id: 'date_inception', name: 'Date' },
    { id: 'prem_value', name: 'Premium' }
  ];
  constructor(
    private router: Router,
    private policyService: PolicyService,
    private claimStore: ClaimStore,
    private flowPlayer: FlowPlayerService,
    private userStore: UserStore,
    public quotesService: QuotesService,
    private store: PolicyStore,
    private underwriterService: UnderwriterService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    public policyQuery: PolicyQuery,
    private claimService: ClaimsService,
    private policyStore: PolicyStore,
    private shoppingCartStore: ShoppingCartStore,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    public globalQuestionService: GlobalQuestionService,
    private ref: ChangeDetectorRef,
    private claimGuardService: ClaimGuardService,
  ) {
    const isPolicyRejected = this.router.getCurrentNavigation()?.extras?.state?.policyRejected;
    this.notify = notify();
    if (isPolicyRejected) {
      this.underwriterService.notifyToast(`Policy ${isPolicyRejected} successfully rejected`, 'info');
    }
    this.mode = localStorage.getItem('mode');
  }

  ngOnInit(): void {
    this.globalQuestionService.spinner(true);
    this.person = this.userStore.getValue();
   
    this.globalQuestionService.setPushToken();
    if (!this.mode) {
      this.mode = 'Policies';
    }
    if (this.person) {
      if (this.person.console_access){
        this.underwriting = true;
        this.claims = true;
      }
      if (this.person.underwriter && !this.person?.console_access){
        this.underwriting = true;
        this.mode = "Underwriting";
        
      }
      let parameters = new Map<string, string>();
      parameters.set('category_id', '0');
      parameters.set('username', '');
      parameters.set('person_id', this.person?.person_id?.toString());
      this.globalQuestionService.runCommandNew(`getInsurers`, parameters)
        .subscribe((insurers: any[]) => {
          if (insurers?.length) {
            this.insurers = insurers;
            this.initCustomSelect();
            if (this.brokers.length > 1) {
              $('#select-broker').modal('show');
            } else {
              if (this.person?.broker_id > 0) {
                this.selectedInsurer = insurers?.find(b => b?.insurer_id === this.person?.broker_id);
                this.userStore.update({ brokerage_id: this.person?.broker_id });
              }

              if (this.person?.console_access) {
                this.selectedInsurer = this.insurers[0];
              }
              localStorage.setItem('mode', this.mode);
            }

          }
          this.globalQuestionService.spinner(true);
          this.dtTrigger.next(undefined);
        });

      parameters = new Map<string, string>();
      parameters.set('person_id', this.person?.person_id?.toString());
      this.globalQuestionService.runCommandNew(`getRelationships`, parameters)
        .subscribe(users => {
          this.users = users;
          if (!this.person.console_access && !this.person?.underwriter) {
            this.underwriting = users.filter(b => b.rel_type_id === 3).length > 0;
            this.claims = users.filter(b => b.rel_type_id === 5).length > 0;
          }
        });

      // parameters = new Map<string, string>();
      // this.globalQuestionService.runCommandNew(`getPolicyStatuses`, parameters)
      //   .subscribe(statuses => {
      //     this.statuses = statuses;
      //   });

        this.changeMode(this.mode);
     
    }

    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    const parameters = new Map<string, string>();
    //parameters.set('new_session_id', this.session_details.session_id);
    this.globalQuestionService.runCommandNew('[dbo].[getCancellationReasons]', parameters).subscribe((reasons) => {
      
      if (this.person?.broker_id > 0 || this.person.console_access){
        reasons.forEach(r => {
            this.options.push({value:r?.cancellation_reason_id, label: r?.cancellation_reason})
        });
      }
      else{
        reasons.forEach(r => {
          if (r?.show_client === 1){
            this.options.push({value:r?.cancellation_reason_id, label: r?.cancellation_reason})
          }
        });
      }

    })
    this.setDtOptions();
  }
  setStartDate(event: any): void{
    //console.log(event)
  }
  setEndDate(event: any): void{
   // console.log(event)
  }
  ngAfterViewInit(): void {
    this.globalQuestionService.spinner(false);
    //$('#broker-profile-dropdown').dropdown('toggle');
    setTimeout(() => {
      this.initGlobalSearch();
      this.initFillters();
      
      $('#global-search-input').on('keypress', (e) => {
        if (e.which == 13) {
          this.search_query = e.target.value;
          this.searchChange();
        }
      });
    }, 2000);

  }
  initGlobalSearch(): void {

    var $globalSearch = $("#global-search");
    var $globalSearchInput = $("#global-search-input");
    var $globalSearchClear = $("#global-search-clear");
    var $globalSearchAdvancedTrigger = $("#global-search-advanced");
    var $globalSearchAdvancedModal = $("#advanced-search-modal");
  
  
    // Autocomplete init
    var options = {
      url: function (phrase) {
        return "/assets/global-search-data.json?phrase=" + phrase;
      },
      listLocation: "items",
      getValue: "name",
  
      // matchResponseProperty: "inputPhrase", 
      // enable matchResponseProperty attribute ...the response should include the inputPhrase value (see example in json) to match the incoming request
      // this will ensure we get back the correct request (see: http://easyautocomplete.com/guide#sec-async)         
      requestDelay: 350,  // only perform requests 350ms after each input
      minCharNumber: 2, // will only begin requests if 2 or more characters in input           
  
      template: {
        type: "custom",
        method: function (value, item) {
          console.log(value)
          return "<svg class='icon'><use xlink:href='#" + item.iconId + "'></use></svg><span>" + value + "</span><small>" + item.type + "</small>";
        }
      },
  
      // custom settings to show input value as a 'search all' result
      includePartial: true,
      partialValue: "name",
      partialTemplate: [
        { type: "‒ search all results" },
        { iconId: "search-all" }
      ],
      // end custom settings
  
      adjustWidth: false,
      list: {
        match: {
          enabled: true // show only matched items
        },
        sort: {
          enabled: false
        },
        maxNumberOfElements: 1,
        onLoadEvent: function () {
  
        },
        onShowListEvent: function () {
          $globalSearch.addClass('has-result');
          $('body').addClass('modal-open');
        },
        onHideListEvent: function () {
          $globalSearch.removeClass('has-result');
          $('body').removeClass('modal-open');
        },
        onChooseEvent: function () {
          var value = $globalSearchInput.getSelectedItemData().name;
          var url = location.href.replace('everything.policy-holders','global-search');
          localStorage.setItem('previous-document-page', 'everything.policy-holders');
          location.href = `${url}?q=${value}`;
        },
      }
    };
  
    $globalSearchInput.easyAutocomplete(options);
  
  
    $globalSearchInput
      .on('focus', function () {
        $globalSearch.addClass('is-expanded');
      })
      .on('blur', function () {
        if ($(this).val().length == 0) {
          $globalSearch.removeClass('is-expanded');
        }
      })
      .on('change', function () {
        if ($(this).val().length == 0) {
          $globalSearch.removeClass('is-expanded');
          $globalSearchClear.removeClass('is-active');
        }
      })
      .on('input', function () {
        // show/hide clear button
        if ($(this).val().length > 0) {
          $globalSearchClear.addClass('is-active');
        } else {
          $globalSearchClear.removeClass('is-active');
        }
      });
  
  
    // mobile search trigger & focus search input
    $('#global-search-trigger').on('click', function (e) {
      e.preventDefault();
      $globalSearch.addClass('is-active');
      $globalSearchInput.trigger('focus');
  
  
      // listen for outside clicks and close
      $(document).on('click.outsideglobalsearch', function (e) {
        var $target = $(e.target);
        if (!$target.closest("#global-search").length
          && !$target.closest("#global-search-trigger").length
          && $globalSearchInput.val() === '') {
          $globalSearch.removeClass('is-active');
        }
      });
  
    });
  
    // mobile search back and clear search input
    $('#global-search-back').on('click', function (e) {
      e.preventDefault();
      $globalSearch.removeClass('is-active');
      $globalSearchInput.val("").trigger('input');
  
      $(document).off('click.outsideglobalsearch');
    });
  
    // demo carry global search input value into advanced search modal
    $globalSearchAdvancedModal.on('shown.bs.modal', function (e) {
      $('#advanced-search-keyword')
        .trigger('focus')
        .val($globalSearchInput.val());
  
      // ensure modal is scrolled to top
      $('body').addClass('modal-open');
    });
  
  
    function resetAdvancedSearchForm(){
      $('#advanced-search-form').trigger('reset');
     
      //$('#advanced-search-submit').attr('disabled', true);
      //$('#advanced-search-clear').attr('disabled', true);
    }
  
    // demo clear advanced search form resest on global search clear
    $globalSearchClear.on('click', () => {
      resetAdvancedSearchForm();
      this.search_query = '';
      this.searchChange();
    });
  
    // demo clear advanced search form on modal open
    $globalSearchAdvancedModal.on('show.bs.modal', function () {
      resetAdvancedSearchForm();
    });
  
    // demo clear advanced search form on reset click
    $('#advanced-search-clear').on('click', function (e) {
      e.preventDefault();
      resetAdvancedSearchForm();      
    });
  
  
  }
  initFillters(): void{
    function closeFilters() {
      $('#filters').removeClass('is-active');
      $('#filters-trigger').removeClass('is-active');
    }
    $(document).on('click', '#filters-trigger', function (e) {
      e.preventDefault();
      var $trigger = $(this);
      $trigger.addClass('is-active');
      var $tar = $($trigger.attr('href'));
      $tar.addClass('is-active');
    });

    $(document).on('click', '#filters [data-close="filter"]', function (e) {
      e.preventDefault();
      closeFilters();
    });

    // on outside click
    $(document).on('click.outsidefilters', function (e) {
      var $target = $(e.target);
      if (!$target.closest("#filters").length && !$target.closest('#filters-trigger').length) {
        closeFilters();
      }
    });
    // padding below table is injected if there are fewer than 10 results (to make space for dropdown menus)
    function padTable(table) {
      var $brokerTable = $(table);
      $brokerTable.removeAttr('style');
      var numResults = $brokerTable.find('tbody tr').length;
      if (numResults < 10) {
        var tdHeightInPixels = $brokerTable.find('tbody td:first').outerHeight() || 53;
        var paddingInPixels = (10 - numResults) * tdHeightInPixels;
        $brokerTable.css({ 'padding-bottom': paddingInPixels + 'px' })
      }
    }
    // Column visibility is keyed by column identity (data-col), never by DOM position.
    // Position-based hiding (:nth-child / DataTables column index) drifts the moment a
    // column is hidden or a mode's *ngIf changes the rendered cell count; identity-based
    // hiding via a single `hide-col-<key>` class on the table stays correct in every mode.
    const self = this;
    var COLUMN_PREFS_KEY = self.COLUMN_PREFS_KEY;

    function saveColumnPrefs(filterListId: string) {
      var prefs: any = { showAll: false, columns: {} };
      if ($(filterListId + ' li:eq(0)').find('input[type="checkbox"]').is(':checked')) {
        prefs.showAll = true;
      } else {
        $(filterListId + ' li:not(:eq(0))').each(function () {
          var $checkbox = $(this).find('input[type="checkbox"]');
          prefs.columns[$checkbox.val()] = $checkbox.is(':checked');
        });
      }
      localStorage.setItem(COLUMN_PREFS_KEY, JSON.stringify(prefs));
    }

    function restoreColumnPrefs(filterListId: string) {
      var saved = localStorage.getItem(COLUMN_PREFS_KEY);
      if (!saved) return;
      var prefs = JSON.parse(saved);
      if (prefs.showAll) {
        $(filterListId + ' li').find('input[type="checkbox"]').prop('checked', true);
      } else {
        $(filterListId + ' li:eq(0)').find('input[type="checkbox"]').prop('checked', false);
        $(filterListId + ' li:not(:eq(0))').each(function () {
          var $checkbox = $(this).find('input[type="checkbox"]');
          var colKey = $checkbox.val();
          if (prefs.columns[colKey] !== undefined) {
            $checkbox.prop('checked', prefs.columns[colKey]);
          }
        });
      }
    }

    // restore saved column prefs on load
    restoreColumnPrefs('#column-filter-list');
    restoreColumnPrefs('#mobile-column-filter-list');
    self.applyColumnVisibility();

    // demo show/hide columns
    $('#columns-apply').on('click', function (e) {
      e.preventDefault();
      saveColumnPrefs('#column-filter-list');
      self.applyColumnVisibility();
      $('#column-dropdown .dropdown-toggle').dropdown('hide');
    });

    // demo mobile show/hide columns
    $('#mobile-filter-apply').on('click', function (e) {
      saveColumnPrefs('#mobile-column-filter-list');
      self.applyColumnVisibility();
    });
    // search filters             
    function filterList(e) {
      var $input = $(e.currentTarget);
      var value = $input.val();
      var $filterList = $input.closest('.filter-accordion__search').next('.filter-accordion__list');
      var $inputGroupIcon = $input.next('.input-group-append').find('.input-group-icon');
      var noResults = true;


      function resetState() {
        $inputGroupIcon.removeClass('is-active')
          .find('.icon use').attr('xlink:href', '#search');
        $filterList.find('li').show();
        $filterList.next('p').remove();
        $inputGroupIcon.off('click');
      }

      // clear any 'no results' msg
      $filterList.next('p').remove();

      // if started typing, show 'clear button'
      if ($input.val() !== '') {
        $inputGroupIcon.addClass('is-active')
          .find('.icon use').attr('xlink:href', '#close-circle-small');

        $inputGroupIcon.on('click', function () {
          $input.val('');
          resetState();
          return;
        });
      }

      // if nothing in search box, reset state and exit
      if ($input.val() === '') {
        resetState();
        return;
      }

      // show matching results
      $filterList.find('li').each(function () {
        var $li = $(this);
        var itemVal = $li.find('.custom-input__label').text();
        $li.hide();
        if (itemVal.toLowerCase().includes(value.toLowerCase())) {
          $li.show();
          noResults = false;
        }
      });


      // if no results
      if (noResults) {
        $filterList.after('<p class="text-center text-color-grey-6 font-16 mt-30">No results available.</p>');
      }

    }
  // search filters listener
  $('[data-input="search-filter"]').each(function () {
    $(this).on('input', filterList);
  });
    function initFilterAccordions() {


      // on header checkbox click
      $(document).on('change', '.filter-accordion__header .custom-input input', function () {
        var $checkbox = $(this);
  
        $checkbox.parent('.custom-input').removeClass('is-partial');
  
        // if unchecked, set all children to unchecked
        if (!$checkbox.is(':checked')) {
          $checkbox.closest('.filter-accordion__header')
            .next('.filter-accordion__body')
            .find('.filter-accordion__list .custom-input input')
            .prop('checked', false);
        }
  
      });
  
  
      // check if checkbox siblings are ALL checked or unchecked
      function checkSiblingsAll($checkbox, checked) {
        var $checkboxSiblings = $checkbox.closest('li').siblings('li').find('.custom-input input');
        var allStatus = true;
  
        if (checked) {
          $checkboxSiblings.each(function () {
            if (!$(this).is(':checked')) allStatus = false;
          });
        } else {
          $checkboxSiblings.each(function () {
            if ($(this).is(':checked')) allStatus = false;
          });
        }
  
        return allStatus;
      }
  
  
      // on filter item checkbox click
      $(document).on('change', '.filter-accordion__list li .custom-input input', function () {
  
        var $checkbox = $(this);
        var $headerCheckboxWrap = $checkbox.closest('.filter-accordion__item').find('.filter-accordion__header .custom-input')
  
        // if checked, set header checkbox to partially checked
        if ($checkbox.is(':checked')) {
          $headerCheckboxWrap
            .addClass('is-partial')
            .find('input')
            .prop('checked', true);
  
          // if all siblings checked, set header checkbox to fully checked
          if (checkSiblingsAll($checkbox, true)) {
            $headerCheckboxWrap.removeClass('is-partial');
          }
  
        }
  
        // if all unchecked
        if (!$checkbox.is(':checked') && checkSiblingsAll($checkbox, false)) {
          $headerCheckboxWrap.find('input').prop('checked', false);
        }
  
  
        // demo show number active filters
        var numActiveFilters = 1;
        $('#filters').find('.filter-accordion__list li .custom-input input').each(function () {
          if ($(this).is(':checked')) numActiveFilters++;
        });
        if (numActiveFilters > 0) {
          $('#filters-trigger').removeClass('is-empty').find('span').text(numActiveFilters);
        } else {
          $('#filters-trigger').addClass('is-empty').find('span').text('0');
        }
  
  
      });
  
  
  
    }
    initFilterAccordions();
  
  }
  initDateRangePicker(): void {
    function initSearchRangeDatePicker(params) {
      var dateFormat = "dd M yy";
      function getDate(element) {
        var date;
        try {
          date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
          date = null;
        }
        return date;
      }
  
  
      function dateEntered($input) {
        return $input.val() !== "";
      }
  
      var $searchDateStart = $("#search-date-start")
        .datepicker({
          dateFormat: dateFormat,
          dayNamesMin: $.datepicker._defaults.dayNamesShort,
          numberOfMonths: 1,
          //minDate: 0,
          maxDate: 0,
          showOn: "both",
          buttonText: "",
          showOtherMonths: true,
          showOptions: {
            direction: "down",
          },
        })
        .on("change", function () {
          // set min date of 'end' to selected date, plus 1 day
          var date = getDate(this);
          date.setDate(date.getDate() + 1);
  
          // give it a sec to update the minDate
          setTimeout(function () {
            $searchDateEnd.datepicker("option", "minDate", date);
          }, 200);
  
          // callback if both dates selected
          if (dateEntered($searchDateStart) && dateEntered($searchDateEnd)) {
            if (params?.onValidRangeSelect) params.onValidRangeSelect([$searchDateStart.datepicker('getDate'), $searchDateEnd.datepicker('getDate')]);
          }
  
  
          $("#advanced-search-submit").attr("disabled", false);
        });

      var $searchDateEnd = $("#search-date-end")
        .datepicker({
          dateFormat: dateFormat,
          dayNamesMin: $.datepicker._defaults.dayNamesShort,
          numberOfMonths: 1,
          //minDate: 0,
          maxDate: 0,
          showOn: "both",
          buttonText: "",
          showOtherMonths: true,
          showOptions: {
            direction: "down",
          },
        })
        .on("change", function () {
          // set max date of 'start' to selected date, less 1 day
          var date = getDate(this);
          date.setDate(date.getDate() - 1);
          setTimeout(function () {
            $searchDateStart.datepicker("option", "maxDate", date);
          }, 200);
  
          // callback if both dates selected
          if (dateEntered($searchDateStart) && dateEntered($searchDateEnd)) {
            if (params?.onValidRangeSelect) params.onValidRangeSelect([$searchDateStart.datepicker('getDate'), $searchDateEnd.datepicker('getDate')]);
          }
        });
  
      // if searchDateEnd is already populated, set maxDate of searchDateStart
      if ($searchDateEnd.val() !== "") {
        var date = getDate($searchDateEnd[0]);
        date.setDate(date.getDate() - 1);
        $searchDateStart.datepicker("option", "maxDate", date);
      }
    }
    initSearchRangeDatePicker({
      onValidRangeSelect: function (dateRange) {
        console.log('Start date: ' + dateRange[0]);
        console.log('End date: ' + dateRange[1]);
      }
    });
  }
  activateMore(x: string): void {
    if (x === 'desktop') {
      this.moreActiveDesktop = !this.moreActiveDesktop;
      if (this.moreActiveDesktop) {
        this.selectedDesktopIdx = $('#app-bar-desktop').find('li.is-active').index();
        $('#app-bar-desktop').find('li').eq(this.selectedDesktopIdx).removeClass('is-active');
      }
      else $('#app-bar-desktop').find('li').eq(this.selectedDesktopIdx).addClass('is-active');
    }
    else {
      this.moreActiveMobile = !this.moreActiveMobile;
      if (this.moreActiveMobile) {
        this.selectedIdx = $('#app-bar').find('li.is-active').index();
        $('#app-bar').find('li').eq(this.selectedIdx).removeClass('is-active');
      }
      else $('#app-bar').find('li').eq(this.selectedIdx).addClass('is-active');

    }

  }
  searchChange(): void {
      this.request.search_query = this.search_query;
      this.request.page = 1;
      this.request.start = 0;
      console.log(this.request)
      this.rerender();
  }
  clearSearch(): void{
    this.search_query = '';
    this.searchChange();
  }
  initCustomSelect(): void {
    $(`#selectBroker`).selectmenu({
      change: (_event, data) => {
        this.userStore.update({brokerage_id: data.item.value});
      }
    });
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(undefined);
      //window.location.reload();
    });

  }
  /**
   * Show/hide columns by column identity (data-col) rather than DOM position.
   * A single `hide-col-<key>` class on #broker-table drives both the <th> and every
   * matching <td> through CSS, so it applies to freshly rendered rows automatically and
   * survives DataTables redraws/rerenders. The live checkboxes are the source of truth,
   * and they live outside the table so they persist across rerenders. Re-run from
   * drawCallback so every draw re-asserts the current prefs.
   */
  applyColumnVisibility(): void {
    const $list = $('#column-filter-list');
    if (!$list.length) { return; }
    const $table = $('#broker-table');
    const showAll = $list.find('li:eq(0) input[type="checkbox"]').is(':checked');
    $list.find('li:not(:eq(0)) input[type="checkbox"]').each(function () {
      const $checkbox = $(this);
      const colKey = $checkbox.val();
      if (!colKey) { return; }
      const visible = showAll || $checkbox.is(':checked');
      $table.toggleClass('hide-col-' + colKey, !visible);
    });
    genMobileTableLabels('#broker-table');
  }
  getPolicies(): void {
    this.changeMode('Policies');
  }
  postSignup(policy: any){
    console.log(policy);
    this.policyStore.setActive(policy?.policy_id);
    const policies = [policy];
    this.policyStore.set(policies);
    this.questionFlowSessionStore.update({
      css: policy?.category_name?.substring(0, policy?.category_name?.indexOf('.'))?.toLowerCase(),
    });
    localStorage.setItem('previous-document-page', this.router.url);
    this.router.navigate(['/policy-post-signup-details-required']);
  }
  goTo(policy: any, event: any): void {
    if (event?.target?.nodeName === 'use' ||
      event?.target?.nodeName === 'svg.icon' ||
      event?.target?.nodeName === 'svg' ||
      event?.target?.cellIndex === 6) {
      return;
    }
    if (policy.policy_status !== 'Active' && this.mode === "Quotes"){
       // Alert(`This quote cannot be edited due to it’s current state (${policy.policy_status}).`);
      $('#inactive-modal').modal('show');
      $('.error-text').html(`This quote cannot be edited due to it’s current state (${policy.policy_status}).`);
      return;
    }
    
    localStorage.setItem('previous-document-page', this.router.url);
    try { policy.benefits = JSON.parse(policy?.benefits); } catch (ex) {}
    try { policy.categories = JSON.parse(policy?.categories); } catch (ex) {}
    try { policy.parsedClasses = JSON.parse(policy?.classes); } catch (ex) {}
    try { policy.collation = JSON.parse(policy?.collation); } catch (ex) {}
    try { policy.documents = JSON.parse(policy?.documents); } catch (ex) {}
    try { policy.included = JSON.parse(policy?.included); } catch (ex) {}
    try { policy.person = JSON.parse(policy?.person); } catch (ex) {}
    try { policy.button_status = JSON.parse(policy?.button_status); } catch (ex) {}
    try { policy.parsedRatings = JSON.parse(policy?.ratings); } catch (ex) {}
 //   console.log(policy)
    const policies = [policy];
    this.policyStore.set(policies);
    this.store.setActive(policy.policy_id); // nice
    switch (this.mode) {
      case 'Underwriting':
        this.router.navigate([`/${RouterLinks.UnderwriterLanding}`]);
        break;
      case 'evi':
        this.router.navigate([`/${RouterLinks.UnderwriterLanding}`], {queryParams: {evi: true}});
        break;
      case 'Claims':

        if (policy.resume_flow_path) {
          this.router.navigateByUrl(policy.resume_flow_path);
        } else {
          this.claimService.editClaim(+policy.policy_id, policy.session_id)
            .subscribe((response: any) => {
              if (!response) {
                return;
              }
              var new_session_id = response[0].new_session_id;
              this.questionFlowSessionStore.update({
                session_id: new_session_id,
                category_id: policy?.category_id,
                css: policy?.css,
                flow_id: 14,
                superflow_id: Superflow.personal_claim
              });

              this.shoppingCartStore.reset();

              this.globalQuestionService.getShoppingCart(0, 'question-flow', 0, policy?.product_id ? policy?.product_id : 0)
                .subscribe((shoppingCartItems: ShoppingCartItem[]) => {

                  if (!shoppingCartItems?.length) {
                    return;
                  }
                  let activeCartItem = 0;
                  this.shoppingCartStore.set(shoppingCartItems);
                  if (activeCartItem > 0) {
                    this.shoppingCartStore.setActive(activeCartItem);
                  }
                });
              this.router.navigate([`/${RouterLinks.ClaimEdit}`]);
            });
        }
        break;
      case 'Quotes':
        const parameters = new Map<string, string>();
        parameters.set('session_id', policy.session_id.toString());
        this.globalQuestionService.runCommandNew(`resumeFlow`, parameters)
          .subscribe(flow => {
            this.questionFlowSessionStore.update({
              session_id: policy.session_id
            });
            console.log(flow)
            this.router.navigateByUrl(`/${flow[0]?.url}`);
          });
        break;
      case 'Policies':
        this.router.navigate([`/${RouterLinks.PolicyOverview}`]);
        break;
      case 'Notifications':
        this.router.navigate([`/${RouterLinks.NotificationsLanding}`], { state: { policy } });
        break;
    }
    // if (this.person.underwriter && this.person.broker_id !== 0) {
    //   $('#view-modal').modal('show');
    //   return;
    // }
    // if (this.person.underwriter) {
    //   this.router.navigate([`/${RouterLinks.UnderwriterLanding}`]);
    // } else {
    //   if (this.mode === 'Quotes'){
    //     const parameters = new Map<string, string>();
    //     parameters.set('session_id', policy.session_id.toString());
    //     this.globalQuestionService.runCommandNew(`resumeFlow`, parameters)
    //       .subscribe(flow => {
    //         this.questionFlowSessionStore.update({
    //           session_id: policy.session_id
    //         });
    //         console.log(flow)
    //         this.router.navigateByUrl(`/${flow[0]?.url}`);
    //       });
    //   }
    //   else{
    //     this.router.navigate([`/${RouterLinks.PolicyOverview}`]);
    //   }

    // }
  }

  applyFilters(): void {
    this.rerender();
  }

  /*applyFilter(type: string): void {
    if (type === 'status') {
      if (this.statusFilterAll === 'All') {
        this.policies = this.tablePolicies;
        return;
      }

      this.policies = this.tablePolicies.filter((policy: Policy) =>
        policy?.policy_status === this.statusFilterAll
      );
    }

    if (type === 'product') {
      if (this.productFilterAll === 'All') {
        this.policies = this.tablePolicies;
        return;
      }

      this.policies = this.tablePolicies.filter((policy: Policy) =>
        policy?.category_name === this.productFilterAll
      );
    }
  }*/

  setFilterProduct(product: string): void {
    let selectedOptions = [];
    const checkboxes = document.getElementsByName(product);

    for (const c of checkboxes) {
      const el = c as HTMLInputElement;

      if (el.checked) {
        if (el.value === 'all') {
          selectedOptions = [];
          selectedOptions.push(el.value);
        } else {
          selectedOptions = selectedOptions.splice(selectedOptions.indexOf('all'), 1);
          selectedOptions.push(el.value);
        }

      } else {
        selectedOptions = selectedOptions.splice(selectedOptions.indexOf(el.value), 1);
      }
    }

  }

  setFilterStatus(event: string): void {
    this.statusFilterAll = event;
  }
  checkAddCover(): any {
    if (this.person.console_access) return true;
    else if (this.person.insurer_type_id === 12 || this.person.insurer_type_id === 13 ) return false;
    else if (this.person.underwriter) return false;
    else return true;
  }
  addCover(): void {
    this.router.navigate(['/' + RouterLinks.QuoteWizard], {state: {broker: true}});
  }

  setDtOptions(): void {
    const self = this;
    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      destroy: true,
      serverSide: true,
      //processing: true,
      displayStart: 0,
      //order: [[ 0, 'asc']] ,
      data: null,
      language: {
        info: '<em>_START_-_END_</em> / _TOTAL_',
        lengthMenu: 'Rows per page: _MENU_',
        infoEmpty: 'No entries found',
        processing: 'Processing... please wait'
      },
      dom: 'fr<"table-responsive"t><"table-pagination"<"table-pagination__controls"<"table-pagination__control"l>><"table-pagination__nav"ip>>',
      drawCallback: function (settings) {
        // disable pagination if only 1 page of results
        var pagination = $('.table-pagination');
        if (this.api().page.info().pages > 1) {
          $('#table-wrap').removeClass('no-pagination');
        } else {
          $('#table-wrap').addClass('no-pagination');
        }
        // re-assert identity-based column visibility for the freshly drawn rows
        self.applyColumnVisibility();
        setTimeout(() => {
          // TODO: make padTable function and don't use lame timeout
          var $brokerTable = $('#broker-table');
          $brokerTable.css({ 'padding-bottom': 0 })
          var numResults = $brokerTable.find('tbody tr').length;
          if (numResults < 11) { 
              var tdHeightInPixels = 53;
              var paddingInPixels = (11 - numResults) * tdHeightInPixels;
              $brokerTable.css({ 'padding-bottom': paddingInPixels + 'px' });
          } 
        }, 1000);
      },
      ajax: (dataTableParams: any, callback) => {
        
        if (this.mobileSort) this.request.sort_order = this.sort;
        else this.request.sort_order = dataTableParams.order[0].dir;
        this.globalQuestionService.spinner(true);
        if (dataTableParams?.length) {
          this.request.page_size = dataTableParams?.length;
        }
        if (dataTableParams?.start && dataTableParams?.length) {
          this.request.page = Math.floor((dataTableParams?.start + dataTableParams?.length) / dataTableParams?.length);
        }
        if (dataTableParams?.start === 0) this.request.page = 1;
        this.request.person_id = this.person?.person_id;
        this.request.broker_id = this.selectedInsurer?.insurer_id ? this.selectedInsurer?.insurer_id : 0;
        this.request.product_type_id = 1;

        if (this.brokerage_ids?.length) {
          this.request.brokerage_id = this.brokerage_ids.join(',');
        }

        if (this.broker_ids?.length) {
          this.request.broker = this.broker_ids.join(',');
        }
        else{
          this.request.broker = "";
        }

        if (this.status_ids?.length) {
          this.request.status = this.status_ids.join(',');
        }

        if (this.product_ids?.length) {
          this.request.product = this.product_ids.join(',');
        }
        // this.request.sort_field = 'name';
        // this.request.sort_order = 'asc';
        this.isEmpty = false;
        if (this.mode === 'Policies' || this.mode === 'Notifications') {
          this.policyService.getPolicies2(this.request)
            .subscribe((res: any[]) => {
              
              if (res?.length && res[0]?.data) {
                this.policies = JSON.parse(res[0]?.data);
                this.categories = this.policies[0]?.categories;
                callback({
                  recordsTotal: res[0]?.recordstotal ?? 10,
                  recordsFiltered: res[0]?.recordsfiltered ?? 10,
                  displayStart: dataTableParams?.start
                });
                setTimeout(() => {
                  initTableSearch($('#policy-table'));
                }, 1000);
                this.brokers = this.users.filter(b => b.rel_type_id === 0 || b.rel_type_id === 2);
                
                // demo table search
                $('#broker-table').on('draw', () => {
                  
                });

                genMobileTableLabels('#broker-table');
                
                //this.sortTable();
                
                this.globalQuestionService.spinner(false);
              } else {
                this.globalQuestionService.spinner(false);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  displayStart: 0
                });
                this.isEmpty = true;
              }
              //this.initFillters();
            }, error => {
              this.globalQuestionService.spinner(false);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                displayStart: 0
              });
              $('#error-modal').modal('show');
              $('.error-text').html(error?.error?.Message);
            });
            this.moreActiveDesktop = false;
        } 
        if (this.mode === 'Quotes') {
          this.quotesService.getQuotes2(this.request)
            .subscribe((res: any[]) => {
              
              if (res?.length && res[0]?.data) {
                this.policies = [];
                const quotes = JSON.parse(res[0]?.data);
                //this.categories = quotes[0].categories;
                if (quotes?.length) {
                  for (const quote of quotes) {
                    this.policies.push(quote);
                  }
                }
                callback({
                  recordsTotal: res[0]?.recordstotal ?? 10,
                  recordsFiltered: res[0]?.recordsfiltered ?? 10,
                  displayStart: dataTableParams?.start
                });
                setTimeout(() => {
                  initTableSearch($('#policy-table'));
                }, 1000);
                this.brokers = this.users.filter(b => b.rel_type_id === 0 || b.rel_type_id === 2);

                genMobileTableLabels('#broker-table');
                // initFilters(
                //   {
                //     filterWrap: $('#filter-dropdown'),
                //     filterList: $('#status-filter-list, #products-filter-list'),
                //     filterBtn: $('#filter-apply'),
                //     mobileFilterWrap: $('#modal-traymenu-filters'),
                //     mobileFilterList: $('#mobile-status-filter-list, #mobile-products-filter-list'),
                //     mobileFilterBtn: $('#mobile-filter-apply')
                //   }
                // );
                //this.sortTable();
                //this.initFillters();
                this.globalQuestionService.spinner(false);
              } else {
                callback({
                  recordsTotal: res[0]?.recordstotal ?? 10,
                  recordsFiltered: res[0]?.recordsfiltered ?? 10,
                  displayStart: dataTableParams?.start,

                });
                this.isEmpty = true;
                this.globalQuestionService.spinner(false);
              }
              console.log(Object.keys(this.policies[0]));
              
            }, error => {
              this.globalQuestionService.spinner(false);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                displayStart: 0
              });
              $('#error-modal').modal('show');
              $('.error-text').html(error?.error?.Message);
            });
            this.moreActiveDesktop = false;
        }
        if (this.mode === 'Claims') {
          let parameters = new Map<string, string>();
          parameters.set('broker_id', this.request?.broker_id?.toString());
          parameters.set('page', this.request?.page?.toString());
          parameters.set('page_size', this.request?.page_size?.toString());
          parameters.set('person_id', this.request?.person_id?.toString());
          parameters.set('product', this.request?.product?.toString());
          parameters.set('search_query', this.request?.search_query?.toString());
          parameters.set('broker', this.request?.broker?.toString());
          parameters.set('status', this.request?.status?.toString());
          parameters.set('brokerage_id', this.request?.brokerage_id?.toString());
          this.globalQuestionService.runCommandNew(`getClaims2`, parameters, false)
            .subscribe((res: any[]) => {
              if (res?.length && res[0]?.data) {
                this.policies = [];
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  displayStart: dataTableParams?.start
                });
                this.globalQuestionService.spinner(false);
                setTimeout(() => {
                  initTableSearch($('#policy-table'));
                }, 1000);
                //this.brokers = this.users.filter(b => b.rel_type_id === 5);
                
                const quotes = JSON.parse(res[0]?.data);

                
                if (quotes?.length) {
                  for (const quote of quotes) {
                    this.policies.push(quote);
                  }
                }

                callback({
                  recordsTotal: res[0]?.recordstotal ?? 10,
                  recordsFiltered: res[0]?.recordsfiltered ?? 10,
                  displayStart: dataTableParams?.start
                });
               
                // demo table search
                $('#broker-table').on('draw.dt', () => {

                });

                genMobileTableLabels('#broker-table');
                // initFilters(
                //   {
                //     filterWrap: $('#filter-dropdown'),
                //     filterList: $('#status-filter-list, #products-filter-list'),
                //     filterBtn: $('#filter-apply'),
                //     mobileFilterWrap: $('#modal-traymenu-filters'),
                //     mobileFilterList: $('#mobile-status-filter-list, #mobile-products-filter-list'),
                //     mobileFilterBtn: $('#mobile-filter-apply')
                //   }
                // );
                //this.sortTable();
                //this.initFillters();
                this.globalQuestionService.spinner(false);
              } else {
                this.globalQuestionService.spinner(false);
                this.isEmpty = true;
              }
            }, error => {
              this.globalQuestionService.spinner(false);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                displayStart: 0
              });
              $('#error-modal').modal('show');
              $('.error-text').html(error?.error?.Message);
            });
            this.moreActiveDesktop = false;
        }
        if (this.mode === 'Underwriting') {
          this.policies = [];
          let view = 'policy';
          if (this.uwView !== 'Policies'){
                 view = 'quote';
          }
          let parameters = new Map<string, string>();
          parameters.set('broker_id', this.request?.broker_id?.toString());
          parameters.set('page', this.request?.page?.toString());
          parameters.set('policy_quote', view);
          parameters.set('page_size', this.request?.page_size?.toString());
          parameters.set('person_id', this.request?.person_id?.toString());
          parameters.set('product', this.request?.product?.toString());
          parameters.set('search_query', this.request?.search_query?.toString());
          parameters.set('broker', this.request?.broker?.toString());
          parameters.set('status', this.request?.status?.toString());
          parameters.set('brokerage_id', this.request?.brokerage_id?.toString());
          if (this.request?.sort_field) {
            parameters.set('sort_field', this.request?.sort_field);
          }
          if (this.request?.sort_order) {
            parameters.set('sort_order', this.request?.sort_order);
          }
          this.globalQuestionService.runCommandNew(`getUnderwriting`, parameters, false)
            .subscribe((res: any[]) => {
              if (res?.length && res[0]?.data) {
                let policies: any;
                policies = JSON.parse(res[0]?.data);

                if (policies?.length) {
                  for (const policy of policies) {
                    this.policies.push(policy);
                  }
                }

                callback({
                  recordsTotal: res[0]?.recordstotal ?? 10,
                  recordsFiltered: res[0]?.recordsfiltered ?? 10,
                  displayStart: dataTableParams?.start
                });
                setTimeout(() => {
                  initTableSearch($('#policy-table'));
                }, 1000);
                this.brokers = this.users.filter(b => b.rel_type_id === 0 || b.rel_type_id === 2);
                // demo table search
                $('#broker-table').on('draw.dt', () => {

                });

                genMobileTableLabels('#broker-table');
                // initFilters(
                //   {
                //     filterWrap: $('#filter-dropdown'),
                //     filterList: $('#status-filter-list, #products-filter-list'),
                //     filterBtn: $('#filter-apply'),
                //     mobileFilterWrap: $('#modal-traymenu-filters'),
                //     mobileFilterList: $('#mobile-status-filter-list, #mobile-products-filter-list'),
                //     mobileFilterBtn: $('#mobile-filter-apply')
                //   }
                // );
                //this.initFillters();
                //this.sortTable();
                this.globalQuestionService.spinner(false);
              } else {
                this.globalQuestionService.spinner(false);
                this.isEmpty = true;
              }
              $('#sidesheet-appbar-more').removeClass('is-active');
             
            }, error => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                displayStart: 0
              });
              this.globalQuestionService.spinner(false);
              $('#error-modal').modal('show');
              $('.error-text').html(error?.error?.Message);
            });
            this.moreActiveDesktop = true;
        }
        this.mobileSort = false;
      },
      
    };
  }
  getSortName(id: string): string {
    return this.SortColumns.find(s => s.id === id)?.name;
  }
  onBrokerageFilterChange(value: any): void {
    if (value === 'all') {
      if ($('#brokerage-all-checkbox').is(':checked')) {
        this.brokerage_ids = [];
        this.insurers.forEach(i => {
          this.brokerage_ids.push(i.insurer_id);
        })
      }
      else {
        $('.brokerage-checkbox').each(function () {
          $(this).prop('checked', false);
        })
      }
      return;
    }
    if (this.brokerage_ids?.length === this.insurers?.length) {
      this.brokerage_ids = [];
    }
    if (this.brokerage_ids?.includes(value)) {
      const index = this.brokerage_ids.findIndex(x => x === value);

      if (index > -1) {
        this.brokerage_ids.splice(index, 1);
      }
    } else {
      this.brokerage_ids.push(value);
    }
  }

  onBrokerFilterChange(value: any): void {
    if (value === 'all') {
      if (this.person.console_access){
        this.broker_ids = []; 
      }
      else{
        if ($('#broker-all-checkbox').is(':checked')){
          this.broker_ids = [];
          this.brokers.forEach(b => {
            this.broker_ids.push(b.person_id);
          })
          console.log(this.broker_ids)
        }
        else{
          this.broker_ids = []; 
          $('.broker-checkbox').each(function(){
            $(this).prop('checked',false);
          })
        }
      }
      return;
    }
    if (this.broker_ids?.length === this.brokers?.length) {
      this.broker_ids = [];
    }
    if (this.broker_ids?.includes(value)) {
      const index = this.broker_ids.findIndex(x => x === value);
      if (index > -1) {
        this.broker_ids.splice(index, 1);
      }
    } else {
      this.broker_ids.push(value);
    }
  }

  onStatusFilterChange(value: any): void {
    
    if (value === 'all') {
      this.status_ids = [];
      this.statuses.forEach(s => {
        if (this.mode === "Policies"){
          this.status_ids.push(s.policy_status_id);
        }
        else{
          this.status_ids.push(s.quote_status_id);
        }
        
      })
      return;
    }

    if (this.status_ids?.length === this.statuses?.length) {
      this.status_ids = [];
    }
    if (this.status_ids?.includes(value)) {
      const index = this.status_ids.findIndex(x => x === value);

      if (index > -1) {
        this.status_ids.splice(index, 1);
      }
    } else {
      this.status_ids.push(value);
    }
  }

  onProductFilterChange(value: any): void {
    if (value === 'all') {
      this.product_ids = [];
      for (const p of this.categories) {
        this.product_ids.push(p?.product_category_id);
      }
      return;
    }
    if (this.product_ids?.length === this.categories?.length) {
      this.product_ids = [];
    }
    if (this.product_ids?.includes(value)) {
      const index = this.product_ids.findIndex(x => x === value);

      if (index > -1) {
        this.product_ids.splice(index, 1);
      }
    } else {
      this.product_ids.push(value);
    }
  }

  checkIfAllProductsChecked(): boolean {
    return this.categories?.every(p => this.product_ids.includes(p?.product_category_id));
  }
  checkifAllBrokers(): boolean {
    return this.brokers.every(b => this.broker_ids.includes(b?.person_id));
  }
  checkifAllBrokerages(): boolean {
    return this.insurers.every(b => this.brokerage_ids.includes(b?.insurer_id));
  }

  changeMode(mode: string): void {
    localStorage.setItem('mode', mode);
    localStorage.setItem("uwView",mode);
    this.moreActiveDesktop = false;

    this.status_ids.push(1);

    let parameters = new Map<string, string>();
    if (mode === "Policies" || mode === "Underwriting" || mode === "Notifications"){
      this.globalQuestionService.runCommandNew(`getPolicyStatuses`, parameters)
      .subscribe(statuses => {
        this.statuses = statuses;
        this.mode = mode;
        this.rerender();
        this.onStatusFilterChange(1);
      });
    }
    else{
      this.globalQuestionService.runCommandNew(`getQuoteStatuses`, parameters)
      .subscribe(statuses => {
        this.statuses = statuses;
        this.mode = mode;
        this.rerender();
        this.onStatusFilterChange(1);
      });
    }
    // setTimeout(() => {
    //   this.initFillters();
    // }, 2000);
    
    
  }
  setView(view): void{
    this.uwView = view;
    let parameters = new Map<string, string>();
    localStorage.setItem("uwView",this.uwView);
    if (this.uwView === "Policies"){
      this.globalQuestionService.runCommandNew(`getPolicyStatuses`, parameters)
      .subscribe(statuses => {
        this.statuses = statuses;
        this.rerender();
      });
    }
    else{
      this.globalQuestionService.runCommandNew(`getQuoteStatuses`, parameters)
      .subscribe(statuses => {
        this.statuses = statuses;
        this.rerender();
      });
    }
    //this.rerender();
  }
  resendQuoteLink(policy: any): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', policy.session_id.toString());
    this.globalQuestionService.runCommandNew(`resumeFlow`, parameters)
      .subscribe(flow => {
        const newParameters = new Map<string, string>();
        newParameters.set('event_id', '2');
        newParameters.set('session_id', policy?.session_id.toString());
        newParameters.set('key', flow[0]?.full_url);
        newParameters.set('email', policy?.person[0]?.email);
        this.globalQuestionService.runCommandNew(`triggerEvent`, newParameters).subscribe(_result => {
          this.notify.init({
            message: '<strong>Quote email sent. &#128522;</strong>', // required
            icon: 'complete',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'success',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
        });
      });
  }
   
  setSort(sort: string): void {
    this.mobileSort = true;
    this.sort = sort;
  }
  setOrder(col: string): void {
    this.request.sort_field = col;
    
  }
  
  unsort(): void {
    this.policies?.sort((a: any, b: any) => {
      if (a.rownum < b.rownum) {
        return -1;
      }
      if (a.rownum > b.rownum) {
        return 1;
      }
      return 0
    })
  }
  sortTable(): void{
    this.policies?.sort( (a: any, b: any) => {
      switch (this.sort) {
        case 'name':
          if (this.order === 'asc') { if (a.person[0]?.first_name < b.person[0]?.first_name) { return -1; } if (a.person[0]?.first_name > b.person[0]?.first_name) { return 1; } return 0; }
          else { if (a.person[0]?.first_name < b.person[0]?.first_name) { return 1; } if (a.person[0]?.first_name > b.person[0]?.first_name) { return -1; } return 0; }
          break;
        case 'id':
          if (this.order === 'asc') { if (a.policy_id < b.policy_id) { return -1; } if (a.policy_id > b.policy_id) { return 1; } return 0; }
          else { if (a.policy_id < b.policy_id) { return 1; } if (a.policy_id > b.policy_id) { return -1; } return 0; }
          break;
        case 'broker':
          if (this.order === 'asc') { if (a.broker_user < b.broker_user) { return -1; } if (a.broker_user > b.broker_user) { return 1; } return 0; }
          else { if (a.broker_user < b.broker_user) { return 1; } if (a.broker_user > b.broker_user) { return -1; } return 0; }
          break;
        case 'product':
          if (this.order === 'asc') { if (a.category_name < b.category_name) { return -1; } if (a.category_name > b.category_name) { return 1; } return 0; }
          else { if (a.category_name < b.category_name) { return 1; } if (a.category_name > b.category_name) { return -1; } return 0; }
          break;
        case 'status':
          if (this.order === 'asc') { if (a.policy_status < b.policy_status) { return -1; } if (a.policy_status > b.policy_status) { return 1; } return 0; }
          else { if (a.policy_status < b.policy_status) { return 1; } if (a.policy_status > b.policy_status) { return -1; } return 0; }
          break;
        case 'uw':
          if (this.order === 'asc') { if (a.uw_status < b.uw_status) { return -1; } if (a.uw_status > b.uw_status) { return 1; } return 0; }
          else { if (a.uw_status < b.uw_status) { return 1; } if (a.uw_status > b.uw_status) { return -1; } return 0; }
          break;
        case 'date':
          if (this.order === 'asc') { if (a.date_inception < b.date_inception) { return -1; } if (a.date_inception > b.date_inception) { return 1; } return 0; }
          else { if (a.date_inception < b.date_inception) { return 1; } if (a.date_inception > b.date_inception) { return -1; } return 0; }
          break;
        case 'premium':
          if (this.order === 'asc') { if (a.prem_value < b.prem_value) { return -1; } if (a.prem_value > b.prem_value) { return 1; } return 0; }
          else { if (a.prem_value < b.prem_value) { return 1; } if (a.prem_value > b.prem_value) { return -1; } return 0; }
          break;
        default: return 0;
      }
    });
  }
 
  startClaim(policy: any): void {
    this.policyStore.set([policy]);
    this.policyStore.setActive(policy.policy_id);
    // guard against the policy holder, never the logged-in user (this.person here
    // is the logged-in user, unlike on the policy-* detail pages).
    this.claimGuardService.startClaimFlow(policy?.policy_id, 0, 0, 0, policy?.person?.[0]?.person_id, false)
      .subscribe(result => {
        if (result) {
          this.emergencyServicesModalComponent.showModal(result);
        }
      });
  }
  removeClaim(claim_id: number){
    if(!claim_id) return;
    const parameters = new Map<string, string>();
    parameters.set('claim_id', claim_id.toString());
    this.globalQuestionService.spinner(true);
    this.globalQuestionService.runCommandNew('removeClaim', parameters)
      .subscribe((response: any) => {
        this.rerender();
      });
  }
  downloadQuoteSchedule(item: any): void{
    localStorage.setItem('previous-document-page', this.router.url);
    //window.open(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${item?.policy_id}&print=false&pdf=true`);
    this.router.navigateByUrl(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${item?.policy_id}&print=false&pdf=true`);
  }
  reactivateQuote(item: any): void {
    const parameters = new Map<string, string>();
    parameters.set('quote_id', item.policy_id.toString());
    this.globalQuestionService.spinner(true);
    this.globalQuestionService.runCommandNew('dbo.reactivateQuote', parameters)
      .subscribe((response: any) => {
        console.log(response);;
        Alert(response[0].status);
        this.rerender();
      });
  }
  viewTranscript(item: any): void{
    localStorage.setItem('previous-document-page', this.router.url);
    window.open(`${RouterLinks.PolicyTranscript}?session_id=${item?.session_id}&print=false&pdf=true`);
    //this.router.navigateByUrl(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${item?.policy_id}&print=false&pdf=true`);
  }
  complianceVault(item: any): void {
    console.log(item);
    const policies = [item];
    this.policyStore.set(policies);
    this.store.setActive(item.policy_id); // nice
    this.router.navigate(['/' + RouterLinks.ComplianceVault], {state: {policy: item}});

  }
  editProfile(item: any, profile: boolean = true): void {
    const policies = [item];
    this.policyStore.set(policies);
    this.store.setActive(item.policy_id); // nice
    this.questionFlowSessionStore.update({
      session_id: item.session_id,
      category_id: item?.category_id,
      css: item?.css,
      flow_id: 0,
      superflow_id: 0
    });
    this.router.navigate(['/' + RouterLinks.EditProfile], {queryParams: {isProfile: profile}});
  }
  setPolicy(policy: any): void {
    this.selectedPolicy = policy;

  }
  openAssignBroker(policy: any): void {
    this.selectedPolicy = policy;
  }
  onPolicyActionChange(event: boolean): void {
    if (event) {
      this.globalQuestionService.spinner(true);
      this.getPolicies();
    }
  }
  openPauseCoverFromCancel(value: boolean): void {
    if (value) {
      this.openPauseModal();
    }
  }
  openPauseModal(): void {
    this.selectedEntity = Entity.Policy;
    this.pausePolicyComponent.showModal(this.selectedEntity);
  }
  editPolicy(policy: Policy, type: string): void {
    this.globalQuestionService.spinner(true);
    this.selectedPolicy = policy;
    this.policyService.editPolicy(this.selectedPolicy?.policy_id, this.selectedPolicy?.session_id)
      .subscribe((result: any[]) => {
        if (result?.length) {
          const tempPolicy = JSON.parse(JSON.stringify(result[0]));
          tempPolicy.collation = [];
          tempPolicy.benefits = JSON.parse(tempPolicy?.benefits);
          tempPolicy.categories = JSON.parse(tempPolicy?.categories);
          tempPolicy.classes = JSON.parse(tempPolicy?.classes);
          tempPolicy.collation = JSON.parse(result[0]?.collation);
          tempPolicy.documents = JSON.parse(tempPolicy?.documents);
          tempPolicy.included = JSON.parse(tempPolicy?.included);
          tempPolicy.person = JSON.parse(tempPolicy?.person);
          try { tempPolicy.person[0].policy_inception_date = JSON.parse(tempPolicy?.person[0]?.policy_inception_date)[0] || {}; } catch { }
          tempPolicy.ratings = JSON.parse(tempPolicy?.ratings);
          tempPolicy.button_status = JSON.parse(tempPolicy?.button_status);
          this.selectedPolicy = tempPolicy;
          //this.new_session_id = this.policy.session_id;

          this.frequency_id = this.selectedPolicy?.collation?.find(item => item?.entry_type === 'product_selected')?.frequency_id;
          this.globalQuestionService.spinner(false);
          localStorage.setItem('previous-document-page', this.router.url);
          if (type === 'pause') {
            this.openPauseModal();
          } else if (type === 'cancel') {
            this.openCancelModal();
          } else if (type === 'resume') {
            this.openResumeModal();
          } else if (type === 'restore') {
            this.openRestoreModal();
          }
        }
      }, err => {
        this.globalQuestionService.spinner(false);
      });
  }
  
  openCancelModal(): void {
    this.selectedEntity = Entity.Policy;
    this.cancelPolicyComponent.showCancelModal(this.selectedEntity);
  }

  openResumeModal(): void {
    this.selectedEntity = Entity.Policy;
    this.resumePolicyComponent.showResumeModal(this.selectedEntity);
  }

  openRestoreModal(): void {
    this.selectedEntity = Entity.Policy;
    this.restorePolicyComponent.showRestoreModal(this.selectedEntity);
  }
  resetFilters():void{
    var chks = document.querySelectorAll("#filters input[type='checkbox']");
    chks.forEach( (c: any) => {
      console.log(c)
      c.checked = false;
    });
  }
  globalSearch(): void {

  }
  cancelPolicy(): void {
    $("#cancel-policy-uw-date-modal").modal('show');
    console.log(this.selectedPolicy)
  }
  setUwDate(event: any): void {
    this.uwDate = event;
  }
  getReasonText(): void{
    this.reason.text = this.responsetext;
    console.log(this.reason)
    if (this.reason?.id > 0 && this.reason?.text !== ""){
      this.reasonProvided = true;
    }
    else{
      this.reasonProvided = false;
    }
  }
  getReasonID(event: any): void{
    this.reason.id = +event;
    
    if (this.reason?.id > 0 && this.reason?.text !== ""){
      this.reasonProvided = true;
    }
    else{
      this.reasonProvided = false;
    }
  }
  uwCancellationRequest(): void{
    this.globalQuestionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('policy_id', this.selectedPolicy.policy_id.toString());
    parameters.set('cancellation_date', this.uwDate);
    parameters.set('cancellation_reason_id', this.reason?.id.toString());
    parameters.set('user_id', this.person?.person_id.toString());
    parameters.set('cancellation_description', this.reason?.text);
    this.globalQuestionService.runCommandNew('[cancelPolicy]', parameters).subscribe((response) => {
      //console.log(response);
      $("#cancel-policy-uw-date-modal").modal('hide');
      this.rerender();
    })
  }
  addPersonToBlacklist(): void{
    
    const parameters = new Map<string, string>();
    parameters.set('person_id', this.selectedPolicy?.person_id.toString());
    parameters.set('blacklist_level', '1');
    parameters.set('comment', this.blacklistReason);
    this.globalQuestionService.runCommandNew('addPersonToBlacklist', parameters).subscribe((response) => {
      if (response[0].result.toLowerCase().includes('added')){
        let name = response[0].first_name;
        this.notify.init({
          message: '<strong>'+name+' added to blacklist. &#128522;</strong>', // required
          icon: 'complete',   // default: null; options: 'info', 'complete', or any icon-name really
          style: 'bootstrap', // default: null; options: 'bootstrap', 'font-awesome', or any custom class
          timeout: 5000, // default: 3000; time in milliseconds before notification disappears
          dismissible: true, // default: true; can be set to false to make notification sticky
        });
        
      }
      if (response[0].result.toLowerCase().includes('updated')){
        let name = response[0].first_name;
        this.notify.init({
          message: '<strong>'+name+' is already on the blacklist, reason has been updated. &#128522;</strong>', // required
          icon: 'complete',   // default: null; options: 'info', 'complete', or any icon-name really
          style: 'bootstrap', // default: null; options: 'bootstrap', 'font-awesome', or any custom class
          timeout: 5000, // default: 3000; time in milliseconds before notification disappears
          dismissible: true, // default: true; can be set to false to make notification sticky
        });
        
      }
      this.blacklistReason = "";
      
    })
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
